import React from "react"
import propTypes from "prop-types"

import Label from "../Label"
import ErrorMessage from "../ErrorMessage"

const Input = ({ field, onChange, isSubmitted }) => {
  return (
    <>
      {field.label && <Label label={field.label} htmlFor={field.name} />}

      <input
        id={field.name}
        type={field.type}
        name={field.name}
        placeholder={field.placeholder}
        value={field.value}
        onChange={e => onChange(field.name, "value", e.target.value)}
        className={[
          "form_element",
          field.class,
          isSubmitted && !!field.message && field.required ? " is-invalid" : ""
        ].join(" ")}
      />

      {field.icon && <div className="form_element_icon">{field.icon}</div>}

      <ErrorMessage message={field.message} />
    </>
  )
}

Input.propTypes = {
  field: propTypes.shape({
    label: propTypes.string,
    placeholder: propTypes.string,
    name: propTypes.string.isRequired,
    type: propTypes.string.isRequired,
    value: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    message: propTypes.string,
    icon: propTypes.string,
    required: propTypes.bool.isRequired,
    class: propTypes.string
  }).isRequired,
  onChange: propTypes.func.isRequired,
  isSubmitted: propTypes.bool.isRequired
}

export default Input
